export class ForgeProjectDocumentPreview {
    constructor(model) {
        this.id = model.id;
        this.title = model.title;
        this.thumbnail = model.thumbnail;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
    }
    toRemote() {
        return Object.assign(Object.assign({}, this), { createdAt: this.createdAt.toISOString(), updatedAt: this.updatedAt.toISOString() });
    }
}
